import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { flattenObjectivesTree } from "@examspark/common";
import { Objective, ObjectiveHierarchyType } from "@examspark/types";

import { getObjectivesTree } from "../../utils/objectives-tree";

export const useQueryGetObjectivesTree = <T extends Objective>(
  objectives: T[] | undefined,
  rootType: ObjectiveHierarchyType = "authority",
) => {
  return useQuery({
    queryKey: [
      "objectives-tree",
      rootType,
      ...(objectives?.map((o) => o.id) ?? []),
    ],
    enabled: !!objectives,
    queryFn: () => getObjectivesTree(objectives, rootType),
  });
};

export const useQuerySortObjectivesByTree = <T extends Objective>(
  objectives: T[] | undefined,
  rootType: ObjectiveHierarchyType = "authority",
) => {
  const { data: tree } = useQueryGetObjectivesTree(objectives, rootType);
  return useMemo(() => flattenObjectivesTree(tree, rootType), [rootType, tree]);
};
